"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_use_1 = require("react-use");
exports.useOsmosysStickiedReload = ({ onReload, isLoading, }) => {
    const [stickiedReloading, toggleStickiedReloading] = react_use_1.useToggle(false);
    const showLoadingState = stickiedReloading || isLoading;
    react_1.useEffect(() => {
        if (stickiedReloading) {
            // Reload
            onReload();
            // Keep a loading state going for 1 second:
            const t = setTimeout(() => {
                toggleStickiedReloading(false);
            }, 1000);
            // Clear on unmount:
            return () => {
                toggleStickiedReloading(false);
                clearTimeout(t);
            };
        }
        return () => { };
    }, [stickiedReloading]);
    return {
        reload: react_1.useCallback(() => {
            if (!showLoadingState) {
                toggleStickiedReloading(true);
            }
        }, [showLoadingState]),
        showLoadingState,
    };
};
//# sourceMappingURL=useOsmosysStickiedReload.js.map